import React from 'react'
import PageLayout from "../components/templates/pageLayout/pageLayout";
import ContentBeAnAmbassador from "../components/organisms/contentBeAnAmbassador /contentBeAnAmbassador";

const SerEmbajadora = () => {
  return (
    <PageLayout>
      <ContentBeAnAmbassador/>
    </PageLayout>
  )
}

export default SerEmbajadora
